<template>
  <div class="w-full pt-5 pb-5 h-screen">
    <div class="flex">
      <back-button
        label="Back"
        @onClick="
          $router.push({
            name: 'PerformanceSettings',
            query: { activeTab: 'Targets, Ratings & Rankings' },
          })
        "
        variant="secondary"
        class="mr-4"
      />
      <div
        class="mt-4"
        style="border-left: 1px solid #878e99; height: 1.5rem"
      />
      <div style="width: 300px; margin-top: 0.1rem">
        <h1 class="text-xl text-left font-extrabold ml-4 mt-3">
          {{ title }}
        </h1>
      </div>
      <div class="w-7/12" style="margin-top: 1.2rem">
        <Breadcrumb
          :items="breadcrumbs"
          @onClick="handleBreadcrumbClick($event)"
        />
      </div>
    </div>

    <div style="height: 100%" class="mt-20" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>

    <div class="px-3 h-full  flex flex-col" v-else>
      <ValidationObserver v-slot="{ handleSubmit }" class=" flex flex-col " style="height: 85%;">
        <card class="p-5 flex-1">
          <p class="text-[14px] text-jet capitalize" style="font-weight: 700;">
            Update Performance Rankings and Flags
          </p>

          <div class="flex gap-2">
            <div
              class="flex cursor-pointer items-center ml-auto"
              @click="openSidebar('description')"
            >
              <icon icon-name="icon-edit" size="xs" class="mr-3 text-flame" />
              <span class="text-base font-semibold text-flame" style="margin-top: 0.1rem">
                Edit Performance & Appraisal Flag              </span>
            </div>
          </div>

          <div class="w-full p-2 my-5 flex bg-ghostWhite">
            <div class="w-2/5 text-xs font-black mr-6 uppercase text-romanSilver">
              Performance Band
            </div>
            <div class="w-2/5 text-xs mr-4 ml-1 font-black uppercase text-romanSilver">
              Performance Description
            </div>
            <div class="w-2/5 text-xs mr-6 font-black uppercase text-romanSilver">
              Appraisal Flag
            </div>
          </div>
          <div
            class="px-2 my-6 flex w-full"
            v-for="(rankings, index) in Ranking"
            :key="index"
          >
            <div class="w-2/5 mr-10 flex items-center">
              <div class="text-base text-jet w-1/3 leading-5">
                Score is
              </div>
              <div class="w-2/5 mr-2 label">
                <c-text value="From" disabled label="" />
              </div>
              <div class="w-2/5 mr-2 label">
                <c-text
                  v-if="index === 0"
                  type="number"
                  v-model="rankings.from"
                >
              </c-text>
                <c-text
                  v-else
                  type="number"
                  :rules="rankingRules"
                  :errors="rankings.lowScoreError"
                  v-model="rankings.from"
                  label="value"
                />
              </div>
              <div
                class="font-12 uppercase font-extrabold mr-2 text-jet"
                style="padding: 15px 0px"
              >
                To
              </div>
              <div class="w-2/5 label">
                <c-text
                  placeholder="--"
                  variant="w-full"
                  :errors="rankings.highScoreError"
                  type="number"
                  :rules="rankingRules"
                  v-model="rankings.to"
                  label="value"
                />
              </div>
            </div>

            <div class="w-2/5 mr-6 flex label">
              <c-select
                placeholder="--Description--"
                :options="descriptions"
                :rules="['required']"
                style="margin-top: 5px; width: 100%"
                label="Description"
                v-model="rankings.description"
              />
            </div>

            <div class="w-2/5 ml-4 mr-4 flex label">
              <c-select
                placeholder="--Appraisal Flag--"
                variant="w-full"
                :options="flags"
                :rules="['required']"
                style="margin-top: 5px; width: 100%"
                label="Appraisal flag"
                v-model="rankings.flagId"
              />
            </div>
          </div>
        </card>
        <div class="flex footer_block mt-6">
          <Button
            class="bg-dynamicBackBtn text-white text-center"
            width="8rem"
            @click="handleSubmit(saveRankings)"
          >
            Save
          </Button>
          <Button
            background-color="none"
            class="ml-4 text-darkPurple text-center"
            width="8rem"
            @click="
              $router.push({
                name: 'PerformanceSettings',
                query: { activeTab: 'Targets, Ratings & Rankings' },
              })
            "
          >
            Cancel
          </Button>
        </div>
      </ValidationObserver>
    </div>

    <ValidationObserver v-slot="{ handleSubmit }">
      <RightSideBar
        v-if="sidebarOpen"
        submit="Send"
        @close="closeSidebar"
        @submit="closeSidebar"
        width="500"
        button-class="bg-dynamicBackBtn text-white"
      >
        <template v-slot:title>
          <p class="text-darkPurple">Edit Performance & Appraisal Flag</p>
        </template>
        <template v-slot:subtitle>
          <p class="font-semibold text-darkPurple" style="margin-bottom: 12px">
            Manage performance descriptions and appraisal flags for evaluation criteria
          </p>
        </template>

        <div class="space-y-6 !h-[70vh] overflow-hidden" style="height: 70vh;overflow-x:hidden">
        <div class="space-y-6 h-full overflow-auto oveflow-x-hidden" style="scrollbar-width: thin;">
          <div class="border !border-1 rounded-xl">
            <div
              class="flex justify-between items-center px-4 py-4 cursor-pointer"
              @click="toggleSection('description')"
            >
              <span class="text-romanSilver font-black uppercase font-[900] text-[12px]">
                Performance Description
              </span>
              <div class="flex items-center">
                <span
                  class="text-flame text-[12px] mr-2 cursor-pointer" style="font-weight: 900;"
                  @click.stop="startNewDescription"
                >
                  ADD NEW
                </span>
                <icon
                  :icon-name="isDescriptionOpen ? 'chevronDown' : 'chevronUp'"
                  class="text-romanSilver ml-2"
                  size="xs"
                />
              </div>
            </div>
            <div v-show="isDescriptionOpen" class="px-4 pb-4">
              <div class="space-y-2">
                <div
                  v-for="(desc, idx) in descriptionArray"
                  :key="desc.id || idx"
                  class=" flex justify-between items-center"
                >
                <c-text
                v-model="desc.name"
                placeholder="Enter Performance Description"
                class="w-11/12"
                :disabled="desc.saved"
              />
              <div class="flex w-1/12 h-10">
                <div
                  v-if="desc.saved"
                  class="cursor-pointer flex"
                  @click="openEditDesc(desc)"
                >
                  <icon
                    icon-name="icon-edit"
                    size="xms"
                    class="mt-1 mx-4 text-blueCrayola"
                  />
                </div>
                <div
                  class="flex cursor-pointer"
                  v-else
                  @click="
                    desc.edit
                      ? handleSubmit(editDescription(desc))
                      : handleSubmit(submitDescription(desc))
                  "
                >
                  <icon
                    icon-name="save"
                    class="mt-1 ml-2 text-blueCrayola"
                    size="xms"
                    style="width: 0.8rem"
                  />
                </div>
                <div
                v-if="!desc.saved"
                class="flex cursor-pointer"
                @click="cancelDescriptionEdit(desc, idx)">
                  <icon
                  icon-name="close"
                  size="s"
                  class="mt-1 ml-2 !rounded-full cursor-pointer"
                  @click="cancelDescriptionEdit(desc, idx)"
                />
                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="border !border-1 rounded-xl">
            <div
              class="flex justify-between items-center px-4 py-3 cursor-pointer"
              @click="toggleSection('flag')"
            >
              <span class="text-romanSilver font-black uppercase font-[900] text-[12px]">
                Appraisal Flag
              </span>
              <div class="flex items-center">
                <span
                  class="text-flame  text-[12px] mr-2 cursor-pointer" style="font-weight: 900;"
                  @click.stop="startNewFlag"
                >
                  ADD NEW
                </span>
                <icon
                  :icon-name="isFlagOpen ? 'chevronDown' : 'chevronUp'"
                  class="text-romanSilver ml-2"
                  size="xs"
                />
              </div>
            </div>
            <div v-show="isFlagOpen" class="px-4 pb-4">
              <div class="space-y-2">
                <div
                  v-for="(flag, idx) in appraisalFlags"
                  :key="flag.id || idx"
                  class=" flex justify-between items-center"
                >
                <c-text
                v-model="flag.name"
                placeholder="Enter Appraisal Flag"
                class="w-11/12"
                :disabled="flag.saved"
              />
              <div class="flex w-1/12 h-10">
                <div
                  v-if="flag.saved"
                  class="cursor-pointer flex"
                  @click="openEdit(flag)"
                >
                  <icon
                    icon-name="icon-edit"
                    size="xms"
                    class="mt-1 mx-4 text-blueCrayola"
                  />
                </div>
                <div
                  class="flex cursor-pointer"
                  v-else
                  @click="
                    flag.edit
                      ? handleSubmit(editFlag(flag))
                      : handleSubmit(submitAppraisal(flag))
                  "
                >
                  <icon
                    icon-name="save"
                    class="mt-1 ml-2 text-blueCrayola"
                    size="xms"
                    style="width: 0.8rem"
                  />
                </div>
                <div
                v-if="!flag.saved"
                class="flex cursor-pointer"
                @click="cancelFlagEdit(flag, idx)">
                  <icon
                  icon-name="close"
                  size="s"
                  class="mt-1 ml-2 !rounded-full cursor-pointer"
                />
                </div>
                <!-- <div class="flex cursor-pointer" @click="deleteFlag(flag, index)">
                  <icon icon-name="icon-trash" class="mt-1" size="xs" />
                </div> -->
              </div>


                </div>
              </div>
            </div>
          </div>
        </div>
        </div>


      </RightSideBar>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import BackButton from "@scelloo/cloudenly-ui/src/components/back-button";
import Breadcrumb from "@scelloo/cloudenly-ui/src/components/bread-crumb";
import CText from "@scelloo/cloudenly-ui/src/components/text";
import CSelect from "@scelloo/cloudenly-ui/src/components/select";
import Card from "@/components/Card";
import Icon from "@/components/Icon";
import Button from "@/components/Button";
import RightSideBar from "@/components/RightSideBar";
import Loader from "@/components/Loader";

export default {
  name: "EditRankings",
  components: {
    BackButton,
    ValidationObserver,
    Breadcrumb,
    Card,
    CText,
    RightSideBar,
    CSelect,
    Icon,
    Button,
    Loader,
  },
  data() {
    return {
      breadcrumbs: [
        {
          disabled: false,
          text: "Settings",
          href: "Settings",
          id: "Settings",
        },
        {
          disabled: false,
          text: "Performance",
          href: "PerformanceSettings",
          id: "Performance",
        },
        {
          disabled: false,
          text: "Setup Performance Rankings",
          id: "Edit rankings",
        },
      ],
      rankingRules: [
        "required",
        {
          name: "value",
          rule: (l) => this.validateValue(l),
        },
      ],
      sidebarOpen: false,
      isDescriptionOpen: true,
      isFlagOpen: true,

      title: "Setup Performance Rankings",
      trashIcon: "icon-trash",
      addIcon: "icon-plus",
      Ratings: [],
      Ranking: [],
      lowest_rating: 0,
      highest_rating: 0,
      lastScore: 0,
      disableBtn: false,

      // for flags & descriptions
      flags: [],
      appraisalFlags: [],
      descriptions: [],
      descriptionArray: [],

      loading: true,
    };
  },

  methods: {
    openSidebar(section) {
      this.sidebarOpen = true;
      if (section === "description") {
        this.isDescriptionOpen = true;
        // this.isFlagOpen = false;
      } else if (section === "flag") {
        this.isFlagOpen = true;
        // this.isDescriptionOpen = false;
      } else {
        this.isDescriptionOpen = true;
        this.isFlagOpen = true;
      }
    },
    closeSidebar() {
      this.sidebarOpen = false;
      // No need to clear arrays here, since lists remain; but close any edit states:
      for (let i = 0; i < this.descriptionArray.length; i++) {
        this.descriptionArray[i].edit = false;
        this.descriptionArray[i].saved = this.descriptionArray[i].id != null; // if had id, saved:true; if new unsaved, will be removed on cancel
      }
      // Remove any new unsaved descriptions
      this.descriptionArray = this.descriptionArray.filter((desc) => desc.id != null);
      for (let i = 0; i < this.appraisalFlags.length; i++) {
        this.appraisalFlags[i].edit = false;
        this.appraisalFlags[i].saved = this.appraisalFlags[i].id != null;
      }
      this.appraisalFlags = this.appraisalFlags.filter((flag) => flag.id != null);
    },
    toggleSection(section) {
      if (section === "description") {
        this.isDescriptionOpen = !this.isDescriptionOpen;
      } else if (section === "flag") {
        this.isFlagOpen = !this.isFlagOpen;
      }
    },

    openEditDesc(desc) {
        const indexedDesc = desc;
        indexedDesc.saved = false;
        indexedDesc.edit = true;
      },
    editDescription(description) {
        let payload = {};
        const indexedDesc = description;
        payload = {
          id: description.id,
          orgId: this.$orgId,
          description: description.name,
        };

        indexedDesc.saved = true;
        this.$_updatePerformanceDescription(payload)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.getDescription();
          })
          .catch((error) => {
            this.$toasted.error(error.response.data.message, { duration: 5000 });
            indexedDesc.saved = false;
          });
      },
      deleteDescription(desc, index) {
        if (desc.id) {
          this.$_deletePerformanceDescription(desc.id).then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.getDescription();
          });
        }
        this.descriptionArray.splice(index, 1);
      },

            cancelDescriptionEdit(desc, idx) {
        if (desc.id == null) {
          // it was a new unsaved entry, remove it
          this.descriptionArray.splice(idx, 1);
        } else {
          // revert name to original from descriptions list
          const original = this.descriptions.find((d) => d.id === desc.id);
          if (original) {
            this.descriptionArray[idx].name = original.name;
          }
          this.descriptionArray[idx].edit = false;
          this.descriptionArray[idx].saved = true;
        }
      },

    startNewDescription() {
      const newDesc = {
        id: null,
        name: "",
        saved: false,
        edit: false,
      };
      this.descriptionArray.unshift(newDesc);
      this.isDescriptionOpen = true;
    },
      submitDescription(desc) {
        const indexedDesc = desc;
        const payload = {
          orgId: this.$orgId,
          description: desc.name,
        };
        indexedDesc.saved = true;
        this.$_createPerfomanceDescription(payload)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.getDescription();
          })
          .catch((err) => {
            this.$toasted.error("Error in creating Performance Description", {
              duration: 5000,
            });
            throw new Error(err);
          });
      },

    async getDescription() {
      this.descriptions = [];
      this.descriptionArray = [];
      try {
        const getDescription = await this.$_getPerformanceDescription();
        getDescription.data.performanceDescription.forEach((item) => {
          this.descriptions.push({ id: item.id, name: item.description });
          this.descriptionArray.push({
            id: item.id,
            name: item.description,
            saved: true,
            edit: false,
          });
        });
      } catch (err) {
        throw new Error(err);
      }
    },

    openEdit(flags) {
        const indexedFlags = flags;
        indexedFlags.saved = false;
        indexedFlags.edit = true;
      },

      editFlag(flag) {
        let payload = {};
        const indexedFlag = flag;

        payload = {
          id: flag.id,
          orgId: this.$orgId,
          name: flag.name,
        };

        indexedFlag.saved = true;

        this.$_updateAppraisalFlag(payload)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.getAppraisalFlag();
          })
          .catch((error) => {
            this.$toasted.error(error.response.data.message, { duration: 5000 });
            indexedFlag.saved = false;
          });
      },
    cancelFlagEdit(flag, idx) {
      if (flag.id == null) {
        this.appraisalFlags.splice(idx, 1);
      } else {
        const original = this.flags.find((f) => f.id === flag.id);
        if (original) {
          this.appraisalFlags[idx].name = original.name;
        }
        this.appraisalFlags[idx].edit = false;
        this.appraisalFlags[idx].saved = true;
      }
    },
    startNewFlag() {
      const newFlag = {
        id: null,
        name: "",
        saved: false,
        edit: false,
      };
      this.appraisalFlags.unshift(newFlag);
      this.isFlagOpen = true;
    },
      submitAppraisal(flag) {
        const indexedFlag = flag;

        const payload = {
          orgId: this.$orgId,
          name: flag.name,
        };

        indexedFlag.saved = true;

        this.$_createAppraisalFlag(payload)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.appraisalName = "";
            this.getAppraisalFlag();
          })
          .catch((err) => {
            this.$toasted.error("Error in creating Appraisal Flag", {
              duration: 5000,
            });
            throw new Error(err);
          });
      },

      deleteFlag(flag, index) {
        if (flag.id) {
          this.$_deleteAppraisalFlag(flag.id).then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.getAppraisalFlag();
          });
        }
        this.appraisalFlags.splice(index, 1);
      },
    async getAppraisalFlag() {
      this.flags = [];
      this.appraisalFlags = [];
      try {
        const getAppraisalFlag = await this.$_getAppraisalFlag();
        getAppraisalFlag.data.flags.forEach((flag) => {
          this.flags.push({ id: flag.id, name: flag.name });
          this.appraisalFlags.push({
            id: flag.id,
            name: flag.name,
            saved: true,
            edit: false,
          });
        });
      } catch (err) {
        throw new Error(err);
      }
    },

    saveSideChanges() {
      this.closeSidebar();
    },

    // ---------- Ranking logic unchanged ----------
    watchRanking() {
      this.Ranking.reduce((previous, current) => {
        const previousValue = previous;
        const currentValue = current;

        if (currentValue.from !== "") {
          if (currentValue.from > previousValue.to) {
            currentValue.lowScoreError = [];
            this.disableBtn = false;
          } else {
            currentValue.lowScoreError.push(
              `Value must be greater than ${previousValue.to}`
            );
            this.disableBtn = true;
          }
        }

        if (currentValue.to !== "") {
          if (Number(currentValue.to) <= Number(currentValue.from)) {
            currentValue.highScoreError.push(
              `Value must be greater than ${currentValue.from}`
            );
            this.disableBtn = true;
          } else {
            currentValue.highScoreError = [];
            this.disableBtn = false;
          }
        }

        return current;
      });
    },
    validateValue(l) {
      if (l <= this.lowest_rating) {
        return `Value must be greater than minimum appraisal score ${this.lowest_rating}`;
      }
      if (l > this.highest_rating) {
        return `Value cannot be greater than maximum appraisal score ${this.highest_rating}`;
      }
      if (l > this.lowest_rating && l <= this.highest_rating) {
        this.watchRanking();
      }
      return true;
    },
    deleteRank(rankingId, index) {
      if (!rankingId) {
        this.Ranking.splice(index, 1);
      } else {
        this.$_deleteRanking(rankingId).then((response) => {
          this.$toasted.success(response.data.message, { duration: 5000 });
          this.Ranking.splice(index, 1);
        });
      }
    },
    saveRankings() {
      if (!this.disableBtn) {
        const rankingArray = [];
        this.Ranking.forEach((ranking) => {
          rankingArray.push({
            from: ranking.from,
            to: ranking.to,
            performance_description: ranking.description,
            orgId: ranking.orgId,
            flagId: ranking.flagId,
          });
        });
        const payload = {
          orgId: this.$orgId,
          request: rankingArray,
        };
        this.$_createRanking(payload)
          .then((response) => {
            this.$toasted.success(response.data.message, { duration: 5000 });
            this.$router.push({
              name: "PerformanceSettings",
              query: { activeTab: "Targets, Ratings & Rankings" },
            });
          })
          .catch((err) => {
            this.$toasted.error(err.response.data.message, { duration: 5000 });
          });
      }
    },
    createNewCriteria() {
      let score;
      this.Ranking.forEach((rank) => {
        score = rank.to;
      });
      this.lastScore = score;
      if (this.lastScore < this.highest_rating) {
        if (!this.disableBtn) {
          this.lastScore = Number(this.lastScore);
          this.Ranking.push({
            lowScoreError: [],
            highScoreError: [],
            id: "",
            from: this.lastScore.toString(),
            to: "",
            description: "",
            orgId: this.$orgId,
            flagId: "",
          });
        }
      } else {
        this.$toasted.error(
          `You have reached your maximum appraisal rating of ${this.highest_rating}`,
          { duration: 5000 }
        );
      }
    },
    async getPerfomanceRating() {
      try {
        const getPerfomanceRating = await this.$_getPerfomanceRating();
        const getRanking = await this.$_getRanking();
        const rankingsArry = getRanking.data.rankings;
        this.Ratings = getPerfomanceRating.data.PerformanceRatings;
        const sortedRatings = this.Ratings.sort((a, b) => a.rating - b.rating);
        this.Ratings = sortedRatings;
        this.lowest_rating = Math.min(
          ...this.Ratings.map((item) => item.rating)
        );
        this.highest_rating = Math.max(
          ...this.Ratings.map((item) => item.rating)
        );
        if (rankingsArry.length === 0) {
          this.Ranking.push({
            lowScoreError: [],
            highScoreError: [],
            id: "",
            from: this.lowest_rating !== null ? this.lowest_rating : "---",
            to: "",
            description: "",
            orgId: this.$orgId,
            flagId: "",
          });
        } else {
          this.title = "Edit Performance Rankings";
          this.breadcrumbs[2].text = "Edit Performance Rankings";
          rankingsArry.forEach((rankingItem) => {
            this.Ranking.push({
              lowScoreError: [],
              highScoreError: [],
              id: rankingItem.id,
              from: rankingItem.from,
              to: rankingItem.to,
              description: rankingItem.performance_description,
              orgId: this.$orgId,
              flagId: rankingItem.flagId,
            });
          });
        }
        this.loading = false;
      } catch (err) {
        throw new Error(err);
      }
    },

    handleBreadcrumbClick(event) {
      this.$router.push({
        name: event,
      });
    },
  },

  mounted() {
    this.getPerfomanceRating();
    this.getAppraisalFlag();
    this.getDescription();
  },
};
</script>

<style >
.label label {
  display: none !important;
}
.label .text-razzmataz {
  display: none !important;
}
</style>

<style scoped>
.label label {
  display: none !important;
}
.label .text-razzmataz {
  display: none;
}
.bg-dynamicBackBtn {
  height: 2.7rem;
}
.icon {
  width: 18px;
  height: 18px;
  margin: 12px 0px;
  padding: 3px;
}
.icon-add {
  width: 26px;
  height: 26px;
  margin: 0px 8px;
  padding: 3px;
}
.add__text {
  font-size: 16px;
  letter-spacing: 0.015em;
  margin: 0px 8px;
}
.footer_block {
  width: 800px;
  height: 44px;
  margin-top: autos;
}
.btn-disabled {
  background-color: #eeeeee;
  font-size: 16px;
  cursor: disabled;
}
::v-deep .cloudenly-input {
  padding: 5px 5px 5px 5px !important;
}
</style>

